import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/punto_venta/presentacionProducto';
import Presentacion from './presentacionProducto';


const ms2p = (state) => {
  return {
    ...state.presentacion_pv,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Presentacion);
